import { clearActiveWorkspace } from '@/store/workspaceStore'
import { clearWorkspaceChatSnapshots } from '@/store/workspaceChatCache'

export function resetWorkspaceSession() {
  clearActiveWorkspace()
  clearWorkspaceChatSnapshots()
}
